import { render, staticRenderFns } from "./wbrw.vue?vue&type=template&id=c53ab858&scoped=true&"
import script from "./wbrw.vue?vue&type=script&lang=js&"
export * from "./wbrw.vue?vue&type=script&lang=js&"
import style0 from "./wbrw.vue?vue&type=style&index=0&id=c53ab858&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53ab858",
  null
  
)

export default component.exports